import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import {
  ButtonType,
  CustomTextField,
} from "@BehpardazBarin/frontend_components";
import { customInputProps } from "../constants/Style";
import InfoIcon from "@mui/icons-material/Info";
import { BackButton } from "../components/Common/BackButton";
import { snackActions } from "../utils/SnackbarUtils";
import { useMutation } from "@tanstack/react-query";
import { forgotpassword } from "../services/Forgotpassword";
import { useNavigate } from "react-router";
import { PrimaryCustomButton } from "../components/CustomButtons/PrimaryCustomButton";

const ForgotPassword: React.FC = () => {
  const theme = useTheme();
  const [userCode, setUserCode] = React.useState<string | number>("");
  const [phoneNumber, setPhoneNumber] = React.useState<string | number>("");

  const handleChangeUser = (val: string | number) => {
    setUserCode(val);
  };

  const handleChangePhoneNumber = (val: string | number) => {
    setPhoneNumber(val);
  };
  const forgotpassMutation = useMutation({
    mutationFn: forgotpassword,
  });

  const navigate = useNavigate();
  const handleLogin = () => {
    if (!userCode || !phoneNumber) {
      snackActions.error("لطفا موارد الزامی را کامل بفرمایید");
      return;
    }
    const params = {
      username: userCode,
      mobile: phoneNumber,
    };

    forgotpassMutation.mutate(params, {
      onSuccess: (response) => {
        navigate("/login");
      },
    });
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-around",
      }}
    >
      <BackButton />
      <Box
        sx={{
          alignSelf: "center",
        }}
      >
        <Typography
          variant="h5"
          gutterBottom
          textAlign="center"
          sx={{ fontFamily: "IRANSansXBold" }}
        >
          فراموشی رمز عبور
        </Typography>
        <Typography
          variant="body2"
          mb={6}
          textAlign="center"
          sx={{
            color: theme.palette.text.secondary,
            fontFamily: "IRANSansX",
            // width: "70%", mx: "auto"  ADDED AFTER ADDING AN IsMobile  THIS IS FOR MOBILE
          }}
        >
          لطفا اطلاعات زیر را تکمیل و روی دکمه ثبت کلیک کنید تا رمز عبور جدید
          برای شما پیامک شود.
        </Typography>

        <CustomTextField
          label="کد ملی"
          value={userCode}
          placeholder={"کد ملی خود را وارد کنید..."}
          onChange={handleChangeUser}
          {...customInputProps(theme)}
          autoFocus={true}
        />

        <CustomTextField
          label={"شماره موبایل"}
          value={phoneNumber}
          placeholder={"شماره موبایل خود را وارد کنید..."}
          onChange={handleChangePhoneNumber}
          helperText={
            <Box
              component="span"
              sx={{
                display: "inline-flex",
                alignItems: "end",
                ml: -1,
                mt: 1,
              }}
            >
              <InfoIcon fontSize="small" />
              <Typography
                variant="body2"
                ml={1}
                component="span"
                sx={{ fontFamily: "IRANSansX", fontSize: "12px" }}
              >
                شماره موبایل شما باید با کد ملی شما مطابقت داشته باشد.
              </Typography>
            </Box>
          }
          helperStyle={{
            color: theme.palette.warning.main,
            fontFamily: "IRANSansX",
          }}
          {...customInputProps(theme)}
        />

        <PrimaryCustomButton
          value={"ثبت"}
          onClickHandler={handleLogin}
          buttonType={ButtonType.actionButton}
          customButtonStyle={{
            borderRadius: "12px",
            width: "97%",
            marginTop: 4,
          }}
        />
      </Box>
    </Box>
  );
};

export default ForgotPassword;
